// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `   /* 제품 상세페이지 */
   .pcontainer {
       max-width: 1200px;
       margin: 40px auto 0;
       padding: 0 20px;
   }

   .product {
       display: flex;
       align-items: center;
       gap: 60px;
       margin-bottom: 40px;
       border-bottom: 1px solid #ddd;
       padding-bottom: 40px;
   }

   .product img {
       width: 400px;
       height: 400px;
       object-fit: contain;
       border: 1px solid #ccc;
       border-radius: 6px;
       background: #ffffff;
       flex-shrink: 0;
   }

   .product-info {
       flex: 1;
   }

   .product-title {
       font-size: 28px;
       font-weight: bold;
       margin-bottom: 8px;
   }

   .product-subtitle {
       font-size: 22px;
       font-weight: bold;
       color: #555;
       margin-bottom: 8px
   }

   .product-desc {
       margin-bottom: 12px;
       font-size: 18px;
       line-height: 1.4;
       color: #555;
   }

   /* 2025.10.15 버튼 호버 추가 및 디자인 수정 */
   .product-btn {
       display: flex;
       align-items: center;
       gap: 6px;
       text-decoration: none;
       font-weight: bold;
       color: #001B8B;
       font-size: 1rem;
       font-size: 18px;

   }

   .product-btn:hover {
       font-size: 19px;
   }

   .product-btn svg {
       width: 24px;
       fill: currentColor;
       position: relative;
       top: 2px;
   }

   .product.right {
       display: flex;
  flex-direction: row-reverse !important;
   }

   /* 2025.10.28 수정 */
.product.right .product-info {
  align-items: flex-end; /* 오른쪽형일 때만 오른쪽 정렬 */
}

   .product-info {
       flex: 1;
       text-align: left;
         display: flex;
  flex-direction: column;
   }

   .product.right .product-info {
       text-align: right;
   }

   @media (max-width: 768px) {
       .product {
           flex-direction: column;
       }

       .product.right {
           flex-direction: column;
       }

       .product img {
           width: 300px;
           height: 300px;
       }

       .product-title {
           font-size: 24px;
           font-weight: bold;
           margin-bottom: 8px;
       }

       .product-subtitle {
           font-size: 20px;
           font-weight: bold;
           color: #555;
           margin-bottom: 8px
       }

       .product-desc {
           margin-bottom: 12px;
           font-size: 16px;
           line-height: 1.4;
           color: #555;
       }

   }`, "",{"version":3,"sources":["webpack://./static/css/products.css"],"names":[],"mappings":"GAAG,aAAa;GACb;OACI,iBAAiB;OACjB,mBAAmB;OACnB,eAAe;GACnB;;GAEA;OACI,aAAa;OACb,mBAAmB;OACnB,SAAS;OACT,mBAAmB;OACnB,6BAA6B;OAC7B,oBAAoB;GACxB;;GAEA;OACI,YAAY;OACZ,aAAa;OACb,mBAAmB;OACnB,sBAAsB;OACtB,kBAAkB;OAClB,mBAAmB;OACnB,cAAc;GAClB;;GAEA;OACI,OAAO;GACX;;GAEA;OACI,eAAe;OACf,iBAAiB;OACjB,kBAAkB;GACtB;;GAEA;OACI,eAAe;OACf,iBAAiB;OACjB,WAAW;OACX;GACJ;;GAEA;OACI,mBAAmB;OACnB,eAAe;OACf,gBAAgB;OAChB,WAAW;GACf;;GAEA,iCAAiC;GACjC;OACI,aAAa;OACb,mBAAmB;OACnB,QAAQ;OACR,qBAAqB;OACrB,iBAAiB;OACjB,cAAc;OACd,eAAe;OACf,eAAe;;GAEnB;;GAEA;OACI,eAAe;GACnB;;GAEA;OACI,WAAW;OACX,kBAAkB;OAClB,kBAAkB;OAClB,QAAQ;GACZ;;GAEA;OACI,aAAa;EAClB,sCAAsC;GACrC;;GAEA,kBAAkB;AACrB;EACE,qBAAqB,EAAE,oBAAoB;AAC7C;;GAEG;OACI,OAAO;OACP,gBAAgB;SACd,aAAa;EACpB,sBAAsB;GACrB;;GAEA;OACI,iBAAiB;GACrB;;GAEA;OACI;WACI,sBAAsB;OAC1B;;OAEA;WACI,sBAAsB;OAC1B;;OAEA;WACI,YAAY;WACZ,aAAa;OACjB;;OAEA;WACI,eAAe;WACf,iBAAiB;WACjB,kBAAkB;OACtB;;OAEA;WACI,eAAe;WACf,iBAAiB;WACjB,WAAW;WACX;OACJ;;OAEA;WACI,mBAAmB;WACnB,eAAe;WACf,gBAAgB;WAChB,WAAW;OACf;;GAEJ","sourcesContent":["   /* 제품 상세페이지 */\n   .pcontainer {\n       max-width: 1200px;\n       margin: 40px auto 0;\n       padding: 0 20px;\n   }\n\n   .product {\n       display: flex;\n       align-items: center;\n       gap: 60px;\n       margin-bottom: 40px;\n       border-bottom: 1px solid #ddd;\n       padding-bottom: 40px;\n   }\n\n   .product img {\n       width: 400px;\n       height: 400px;\n       object-fit: contain;\n       border: 1px solid #ccc;\n       border-radius: 6px;\n       background: #ffffff;\n       flex-shrink: 0;\n   }\n\n   .product-info {\n       flex: 1;\n   }\n\n   .product-title {\n       font-size: 28px;\n       font-weight: bold;\n       margin-bottom: 8px;\n   }\n\n   .product-subtitle {\n       font-size: 22px;\n       font-weight: bold;\n       color: #555;\n       margin-bottom: 8px\n   }\n\n   .product-desc {\n       margin-bottom: 12px;\n       font-size: 18px;\n       line-height: 1.4;\n       color: #555;\n   }\n\n   /* 2025.10.15 버튼 호버 추가 및 디자인 수정 */\n   .product-btn {\n       display: flex;\n       align-items: center;\n       gap: 6px;\n       text-decoration: none;\n       font-weight: bold;\n       color: #001B8B;\n       font-size: 1rem;\n       font-size: 18px;\n\n   }\n\n   .product-btn:hover {\n       font-size: 19px;\n   }\n\n   .product-btn svg {\n       width: 24px;\n       fill: currentColor;\n       position: relative;\n       top: 2px;\n   }\n\n   .product.right {\n       display: flex;\n  flex-direction: row-reverse !important;\n   }\n\n   /* 2025.10.28 수정 */\n.product.right .product-info {\n  align-items: flex-end; /* 오른쪽형일 때만 오른쪽 정렬 */\n}\n\n   .product-info {\n       flex: 1;\n       text-align: left;\n         display: flex;\n  flex-direction: column;\n   }\n\n   .product.right .product-info {\n       text-align: right;\n   }\n\n   @media (max-width: 768px) {\n       .product {\n           flex-direction: column;\n       }\n\n       .product.right {\n           flex-direction: column;\n       }\n\n       .product img {\n           width: 300px;\n           height: 300px;\n       }\n\n       .product-title {\n           font-size: 24px;\n           font-weight: bold;\n           margin-bottom: 8px;\n       }\n\n       .product-subtitle {\n           font-size: 20px;\n           font-weight: bold;\n           color: #555;\n           margin-bottom: 8px\n       }\n\n       .product-desc {\n           margin-bottom: 12px;\n           font-size: 16px;\n           line-height: 1.4;\n           color: #555;\n       }\n\n   }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
